import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useScrollBehavior from '../../../landing/useScrollBehavior';
import Logo from '../logo';
import './header.css';

const PAGE_PATH = '/inform3d';

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const { scrollToTop } = useScrollBehavior();

    const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
        }

        e.preventDefault();

        if (location.pathname === PAGE_PATH) {
            scrollToTop();
            navigate(PAGE_PATH, { replace: true });
        } else {
            navigate(PAGE_PATH);
        }
    };

    return (
        <header className="inform__header">
            <div className="inform__header-container">
                <Link to={PAGE_PATH} onClick={handleLogoClick} className="inform__header-logo">
                    <Logo />
                </Link>
            </div>
        </header>
    );
}

export default Header;
